// Library Methods
import { useTranslation } from "react-i18next";
import { useContext, useMemo } from "react";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// Contexts
import { ReportSectionContext } from "src/contexts/reports/ReportSectionContext";

// Constants
import { VISUAL_FIELD_TYPE } from "src/constants/enums";

// Styles
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const ReportVersion = () => {
  const { t } = useTranslation();

  const theme = useTheme();
  const smallerThanSm = useMediaQuery(theme.breakpoints.down("sm"));

  const { examReport } = useContext(ReportSectionContext);

  const deviceVersion = useMemo(
    () => examReport?.device?.version?.match(/\d+(\.\d+)*/)?.[0] ?? "N/A",
    [examReport?.device?.version]
  );

  const isVisualFieldThresholding = useMemo(
    () =>
      examReport?.exam?.type === VISUAL_FIELD_TYPE &&
      examReport?.exam?.algorithm.includes("THRESHOLD"),
    [examReport?.exam?.algorithm, examReport?.exam?.type]
  );

  const metadataVersion = useMemo(
    () =>
      isVisualFieldThresholding
        ? examReport?.postProcessing?.metadataVersion ?? "N/A"
        : undefined,
    [isVisualFieldThresholding, examReport?.postProcessing?.metadataVersion]
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: smallerThanSm ? "column" : "row",
        alignItems: "center",
        justifyContent: "space-around",
      }}
    >
      <Typography sx={{ fontSize: "12px" }}>
        {t("App Version")}: {deviceVersion}
      </Typography>
      {metadataVersion && (
        <Typography sx={{ fontSize: "12px" }}>
          {t("Metadata Version")}: {metadataVersion}
        </Typography>
      )}
    </Box>
  );
};

export default ReportVersion;
